/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { RESOURCE_TYPES } from "@adapptio/lib-core";
import { IEditor } from "../../IEditor";
import { IntegrationEditorEdit } from "./IntegrationEditorEdit/IntegrationEditorEdit";
import { IntegrationEditorEditComponent } from "./IntegrationEditorEdit/IntegrationEditorEditComponent";
import { registerCommands } from "./Commands";
import { registerKeyBindings } from "./KeyBindings";
import { IntegrationEditorCreate } from "./IntegrationEditorCreate/IntegrationEditorCreate";
import { IntegrationEditorCreateComponent } from "./IntegrationEditorCreate/IntegrationEditorCreateComponent";
import { registerMenus } from "./Menus";

export function IntegrationEditorModule(dc: IEditor): void {
	dc.get("logger").debug("Integration Editor module enabled.");

	const resourceSvc = dc.get("resourceService");
	const viewSvc = dc.get("viewService");

	viewSvc.registerView(
		"integrationEditor.create",
		IntegrationEditorCreate,
		IntegrationEditorCreateComponent
	);
	resourceSvc.registerResourceCreateCommand(
		RESOURCE_TYPES.INTEGRATION,
		"integrationEditor.createPage.open"
	);

	viewSvc.registerView("integrationEditor.edit", IntegrationEditorEdit, IntegrationEditorEditComponent);
	resourceSvc.registerResourceView(RESOURCE_TYPES.INTEGRATION, "integrationEditor.edit");

	registerCommands(dc);
	registerKeyBindings(dc);
	registerMenus(dc);
}
